import React from "react";

import { Switch, Route, Redirect } from "react-router-dom";

import ManagerApproval from "./ManagerApproval";

const ApprovalRouter = () => (
  <Switch>
    <Route path="/app/approval/manager/:assignedToId?">
      <ManagerApproval />
    </Route>
    <Redirect to="/app/approval/manager" />
  </Switch>
);

export default ApprovalRouter;
